import {writable} from "svelte/store";

const callbacks: Function[] = []
export const globalConfirm = writable({
    open: false,
    content: "Bist du sicher?",
    confirmed: false,
    confirm(content: string, callback: Function = () => {}) {
        callbacks.push(callback)
        globalConfirm.update((modal:any) => {
            modal.content = content
            modal.confirmed = false
            modal.open = true
            return modal;
        })

    },
    _(){
        globalConfirm.update((modal:any) => {
            modal.open = false
            modal.confirmed = true
            return modal
        })
    }
},() => {
    // make sure the confirmation is reset
    globalConfirm.update((modal:any) => {
        modal.open = false
        modal.confirmed = false
        return modal
    })
    return () => {
        console.log('unsubscribed')
    }

})

globalConfirm.subscribe(modal => {
    if(modal.confirmed && callbacks.length > 0) {
        callbacks[callbacks.length - 1]()
        callbacks.pop()
    }
    // globalModal.set({...modal, confirmed: false})
})
